var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.875V19.875C22 18.0112 20.7252 16.4451 19 16.001M15.5 4.16576C16.9659 4.75915 18 6.19631 18 7.875C18 9.55369 16.9659 10.9909 15.5 11.5842M17 21.875C17 20.0112 17 19.0794 16.6955 18.3443C16.2895 17.3642 15.5108 16.5855 14.5307 16.1795C13.7956 15.875 12.8638 15.875 11 15.875H8C6.13623 15.875 5.20435 15.875 4.46927 16.1795C3.48915 16.5855 2.71046 17.3642 2.30448 18.3443C2 19.0794 2 20.0112 2 21.875M13.5 7.875C13.5 10.0841 11.7091 11.875 9.5 11.875C7.29086 11.875 5.5 10.0841 5.5 7.875C5.5 5.66586 7.29086 3.875 9.5 3.875C11.7091 3.875 13.5 5.66586 13.5 7.875Z",
    stroke: "#667085",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.b7cbe154084369147895903a2321b506.svg";
export { ForwardRef as ReactComponent };